export default __webpack_public_path__ + "static/media/dispatched_true.36381ab4.svg";